import { useEffect, useState } from 'react';
import { preloadResource } from '@djs';
import { getLangConfig, getLangFileUrl, L } from '@lang';
import { importProjectFont } from '@theme';
import langFileConfig from './vkui-lang-config.json';

export function useLoadLangConfig() {
  const [isLangConfigLoading, setIsLangConfigLoading] = useState(true);

  useEffect(() => {
    const langConfig = getLangConfig({
      config: langFileConfig,
      defaultLang: 'ru',
    });

    document.documentElement.lang = langConfig.lang;

    preloadResource({
      as: 'fetch',
      /** если перейдём на vk.ru, поменять */
      href: getLangFileUrl({ origin: 'https://vk.com', lang: langConfig.lang, name: langConfig.name }),
      type: 'application/json',
      /** важно, чтобы браузер считал запросы к lang одинаковыми */
      crossorigin: 'anonymous',
      fetchpriority: 'low',
    });

    Promise.all([
      importProjectFont('vk'),
      L.init({
        config: langConfig,
        debug: false,
        forceFallback: false,
        vkMainUrl: 'https://vk.com',
      }),
    ])
      .then(() => {
        setIsLangConfigLoading(false);
      })
      .catch((e) => console.log(e));
  }, []);

  return { isLangConfigLoading };
}
